import { AES, enc, pad, algo } from 'crypto-js/core';
import { PBKDF2 } from 'crypto-js';
import 'crypto-js/sha256';
import 'crypto-js/aes';
import 'crypto-js/enc-utf8';

export default function decryption(
  encryptedData = '',
  decKey = '',
  decSalt = '',
  decIv = '',
) {
  try {
    const decryptionKey = enc.Utf8.parse(decKey);
    const decryptionSalt = enc.Utf8.parse(decSalt);
    const key = PBKDF2(decryptionKey, decryptionSalt, {
      keySize: 256 / 32,
      iterations: 100,
      hasher: algo.SHA256,
    });
    const iv = enc.Utf8.parse(decIv);
    const decryptedData = AES.decrypt(encryptedData, key, {
      iv,
      padding: pad.NoPadding,
    });
    const decryptedText = decryptedData.toString(enc.Utf8);
    const nonPaddedData = JSON.stringify(decryptedText);
    const replacedData = nonPaddedData.replace(/\\u0000/g, '');
    return JSON.parse(replacedData);
  } catch (error) {
    console.error('An error occurred during decryption:', error);
    return null;
  }
}
